const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const WIDTHS = [480, 960, 1440, 1920, 2560];
const OPTIMIZABLE = /\.(jpe?g|png|webp)$/i;

const withWidth = (url, w) => {
  if (!w) return url;
  if (url.startsWith('/api/files/') && OPTIMIZABLE.test(url)) return `${BACKEND_URL}${url}?w=${w}`;
  if (/images\.unsplash\.com|images\.pexels\.com/.test(url)) {
    const u = new URL(url);
    u.searchParams.set('w', w);
    if (u.hostname.includes('unsplash')) { u.searchParams.set('q', '80'); u.searchParams.set('auto', 'format'); }
    return u.toString();
  }
  return null;
};

export const resolveImageUrl = (url, w) => {
  if (!url) return '';
  const sized = withWidth(url, w);
  if (sized) return sized;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/')) return `${BACKEND_URL}${url}`;
  return url;
};

// Responsive props for <img>: smaller files on phones, lazy by default.
export const responsiveImg = (url, sizes = '100vw', { eager = false } = {}) => {
  const base = { src: resolveImageUrl(url, 1920), decoding: 'async', loading: eager ? 'eager' : 'lazy' };
  if (!url || !withWidth(url, 480)) return base;
  return { ...base, sizes, srcSet: WIDTHS.map((w) => `${withWidth(url, w)} ${w}w`).join(', ') };
};
